import { CircularProgress } from "@mui/material";
import React from "react";
import "./paymentMethod.scss";
import Card from "./Card";
import { Button } from "react-bootstrap";
import useModalWindowControls from "../../Hooks/useModal";
import NewPaymentMethodPopUp from "./NewPaymentMethodPopUp";
import ConfirmDeletePaymentMethodPopUp from "./ConfirmDeletePaymentMethodPopUp";
import usePaymentMethod from "./usePaymentMethod";

function PaymentMethod() {
  const {
    paymentsMethodsRequest,
    addPaymentMethodRequest,
    removePaymentMethodRequest,
    makePrimaryPaymentMethod,
    clearPostNewPaymentMethod,
    clearRemovePaymentMethodRequest,
    paymentMethods,
    postNewPaymentMethod,
    removePaymentMethod,
    primaryPaymentMethod,
    subscriptionPaymentMethod,
    setSubscriptionPaymentMethodRequest,
  } = usePaymentMethod();

  const addCardModal = useModalWindowControls();
  const removeCardModal = useModalWindowControls();

  const paymentMethodsList = paymentMethods.data?.methods?.data ?? [];

  const defaultPaymentMethod =
    paymentMethods.data?.customer?.invoice_settings?.default_payment_method;

  const subscriptions = paymentMethods.data?.subscriptions?.data ?? [];

  return (
    <div className="paymentMethodMain">
      <NewPaymentMethodPopUp
        isVisible={addCardModal.isVisible}
        closeModal={addCardModal.closeModal}
        postNewPaymentMethod={postNewPaymentMethod}
        clearPostNewPaymentMethod={clearPostNewPaymentMethod}
        addPaymentMethodRequest={addPaymentMethodRequest}
      />
      <ConfirmDeletePaymentMethodPopUp
        isVisible={removeCardModal.isVisible}
        closeModal={removeCardModal.closeModal}
        removePaymentMethod={removePaymentMethod}
        removePaymentMethodRequest={removePaymentMethodRequest}
        clearRemovePaymentMethodRequest={clearRemovePaymentMethodRequest}
        id={removeCardModal.openModalData}
      />
      <h5 className="section-title">Credit cards</h5>
      {paymentMethods.pending && (
        <div className="paymentMethodEmpty my-3 d-flex w-100 edit-profile-payment-history-container align-items-center justify-content-center py-3 px-4">
          <CircularProgress />
        </div>
      )}
      {paymentMethods.failed && (
        <div className=" paymentMethodEmptymy-3 d-flex w-100 edit-profile-payment-history-container align-items-center justify-content-center py-3 px-4">
          <button
            className="btn primary-blue-small-btn-40"
            onClick={paymentsMethodsRequest}
          >
            Refresh
          </button>
        </div>
      )}
      {paymentMethods.success && !paymentMethodsList.length && (
        <div className="paymentMethodEmpty my-3 d-flex w-100 edit-profile-payment-history-container align-items-center justify-content-center py-3 px-4">
          <Button
            className="btn primary-blue-small-btn-40"
            onClick={addCardModal.openModal}
          >
            Add your first card
          </Button>
        </div>
      )}
      {paymentMethods.success && (
        <>
          {paymentMethodsList.map((method: any) => (
            <Card
              method={method}
              key={method.id}
              className="mt-3"
              openRemoveCardModal={removeCardModal.openModal}
              defaultPaymentMethod={defaultPaymentMethod}
              makePrimaryPaymentMethod={makePrimaryPaymentMethod}
              primaryPaymentMethod={primaryPaymentMethod}
            />
          ))}
        </>
      )}
      {paymentMethods.success && !!subscriptions.length && (
        <div className="mt-4">
          <h5 className="section-title">Subscriptions</h5>
          <div className="paymentMethodsAddButtonWrapper my-2">
            <Button
              className="btn primary-blue-small-btn-40"
              onClick={addCardModal.openModal}
            >
              Add payment method
            </Button>
          </div>
          {subscriptions.map((subscription: any) => {
            const items = subscription?.items?.data || [];
            const firstItem = items[0] || {};
            const plan = firstItem.plan || firstItem.price || {};
            // Use subscription expiry (current_period_end) as primary display
            const formattedEndDate =
              subscription.current_period_end
                ? new Date(subscription.current_period_end * 1000).toLocaleDateString(
                    "en-US",
                    { month: "2-digit", day: "2-digit", year: "numeric" }
                  )
                : null;
            const name =
              formattedEndDate ||
              plan.nickname ||
              subscription.metadata?.name ||
              "Subscription";

            const status = subscription.status;

            const defaultPmId =
              typeof subscription.default_payment_method === "string"
                ? subscription.default_payment_method
                : subscription.default_payment_method?.id;

            const currentCard = paymentMethodsList.find(
              (m: any) => m.id === defaultPmId
            );

            const isUpdating =
              subscriptionPaymentMethod.subscriptionId === subscription.id &&
              subscriptionPaymentMethod.pending;

            return (
              <div
                key={subscription.id}
                className="payment-history-list w-100 d-flex justify-content-between align-items-center my-2"
              >
                <div className="payment-for-title">
                  <p className="payment-name m-0 text-start">
                    <strong>{name}</strong>
                  </p>
                  <p className="m-0 text-start">
                    Status: {status}
                  </p>
                  <p className="m-0 text-start">
                    Current card:{" "}
                    {currentCard
                      ? `**** ${currentCard.card?.last4}`
                      : defaultPaymentMethod
                      ? "Default card"
                      : "Not set"}
                  </p>
                </div>
                <div>
                  <select
                    className="form-select"
                    onChange={(e) => {
                      if (!e.target.value) return;
                      setSubscriptionPaymentMethodRequest(
                        subscription.id,
                        e.target.value
                      );
                    }}
                    disabled={isUpdating || !paymentMethodsList.length}
                    defaultValue=""
                  >
                    <option value="">Change card...</option>
                    {paymentMethodsList.map((method: any) => (
                      <option key={method.id} value={method.id}>
                        Card **** {method.card?.last4}
                      </option>
                    ))}
                  </select>
                  {isUpdating && (
                    <div className="mt-1">
                      <CircularProgress size={16} />
                    </div>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      )}
      {paymentMethods.success &&
        !!paymentMethodsList.length &&
        paymentMethodsList.length < 2 && (
          <div className="paymentMethodsAddButtonWrapper mt-3">
            <Button
              className="btn primary-blue-small-btn-40"
              onClick={addCardModal.openModal}
            >
              Add card
            </Button>
          </div>
        )}
    </div>
  );
}

export default PaymentMethod;
